const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const OpsSchool = require("./vault/OpsSchool");
const SortableTable = require("./SortableTable");
const Link = require("../core/view/Link");
const URLMake = require("../../shared/URLMake");
const ClassesUtil = require("./util/ClassesUtil");
const EditPencil = require("../office/EditPencil");
const Editable = require("../office/Editable");
const CopyTable = require("./data/CopyTable");
const Input = require("../office/checkout/Input");
const OfficeModal = require("../office/modals/OfficeModal");

const styles = require("./styles/AccountClass.css");

module.exports = createReactClass({
	displayName: "AccountClass",

	propTypes: {
		user: PT.object.isRequired,
		classID: PT.number.isRequired,
		schoolState: PT.object.isRequired,
		showModal: PT.func,
	},

	getInitialState: function() {
		return {
			isPrintModalOpen: false,
			instructions: "",
		};
	},

	getTeacherData: function(schoolState, teachers, isClassActive, isAcademy) {
		const {user} = this.props;
		const editableStaff = OpsSchool.getPartiallyAdminnedStaff(
			schoolState,
			user.userID
		);
		const editableStaffIDs = editableStaff.map(es => es.id);
		return teachers.map(t => {
			const linkTo = URLMake.forUserAccount(t.id);
			const displayName = ClassesUtil.getUserName(t);
			const canEdit = _.includes(editableStaffIDs, t.id) && !isAcademy;
			const isActive = OpsSchool.isStaffResolvedActive(schoolState, t.id);
			const inactiveText = isClassActive && !t.active ? "Inactive" : null;
			return {
				name: (
					<div className={styles.editable}>
						{isActive && isClassActive && canEdit ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: t.id,
										type: "name",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						{canEdit ? (
							<Link to={linkTo} className={styles.link}>
								{displayName}
							</Link>
						) : (
							displayName
						)}
					</div>
				),
				nameValue: displayName,
				email: (
					<div className={styles.editable}>
						{isActive && isClassActive && canEdit ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: t.id,
										type: "email",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						{t.newEmail || t.email}
					</div>
				),
				emailValue: t.newEmail || t.email,
				remove:
					isClassActive && isActive && canEdit && t.id !== user.userID ? (
						<div className={styles.remove}>
							<span
								onClick={() =>
									this.props.showModal("confirmInfo", {
										type: "remove",
										userID: t.id,
										classID: this.props.classID,
										role: "teacher",
									})
								}
							>
								Remove from class
							</span>
						</div>
					) : (
						inactiveText
					),
				inactive: !isActive,
			};
		});
	},

	getStudentData: function(
		schoolState,
		students,
		isClassActive,
		isSchoolAdmin,
		isAcademy
	) {
		return students.map(s => {
			const linkTo = URLMake.forUserAccount(s.id);
			const displayName = ClassesUtil.getStudentName(s);

			const isActive = OpsSchool.isStudentActive(schoolState, s.id);
			// Only schoolLogin is editable
			const usernameEl =
				!s.username &&
				s.schoolLogin &&
				isActive &&
				isClassActive &&
				isSchoolAdmin &&
				!isAcademy ? (
					<div className={styles.editable}>
						<EditPencil
							onClick={() =>
								this.props.showModal("updateInfo", {
									userID: s.id,
									type: "schoolLogin",
								})
							}
							className={styles.pencil}
						/>
						{s.schoolLogin}
					</div>
				) : (
					<div className={styles.editable}>
						{!s.username || !isClassActive ? (
							<div className={styles.pencil} />
						) : null}
						{s.username || s.schoolLogin}
					</div>
				);

			return {
				name: (
					<div className={styles.editable}>
						{isActive && isClassActive && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: s.id,
										type: "name",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						<Link to={linkTo} className={styles.link}>
							{displayName}
						</Link>
					</div>
				),
				nameValue: displayName,
				displayName: (
					<div className={styles.editable}>
						{isActive && isClassActive && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: s.id,
										type: "displayName",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						{s.displayName}
					</div>
				),
				displayNameValue: s.displayName,
				username: usernameEl,
				usernameValue: s.username || s.schoolLogin,
				password: (
					<div className={styles.editable}>
						{isActive && isClassActive && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: s.id,
										type: "password",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						{"*******"}
					</div>
				),
				inactive: !isActive,
				status: isClassActive && !s.active ? "Inactive" : null,
			};
		});
	},

	renderEmptyTable: function(type) {
		const emptyTableText = CopyTable.getEmptyTableCopy(type, "class");
		const textMap = {
			student: "Students",
			teacher: "Teachers",
		};
		return (
			<div className={styles.empty}>
				<div className={styles.emptyTitle}>
					{textMap[type] || _.capitalize(type)}
				</div>
				{emptyTableText}
			</div>
		);
	},

	openPrint: function() {
		this.setState({isPrintModalOpen: true});
	},

	onClose: function() {
		this.setState({isPrintModalOpen: false, instructions: ""});
	},

	updateInput: function(instructions) {
		this.setState({instructions});
	},

	renderModal: function() {
		if (!this.state.isPrintModalOpen) return null;
		return (
			<OfficeModal
				onClose={this.onClose}
				closeOnEsc={true}
				portalContainer={null}
				level="overBar"
				closeOnBackdropClick={false}
				modalClass={styles.modal}
			>
				<div className={styles.container}>
					<div className={styles.text}>Optional sign in directions:</div>
					<div className={styles.input}>
						<Input
							autofocus={true}
							isTextarea={true}
							maxLength={150}
							onUpdate={this.updateInput}
						/>
					</div>
					<Link
						to={URLMake.forClassCards(
							this.props.classID,
							this.state.instructions
						)}
						className={styles.modalButton}
						isNewTab={true}
						forceActionOnNewTab={true}
						clickAction={this.onClose}
					>
						Create Printable Cards
					</Link>
				</div>
			</OfficeModal>
		);
	},

	render: function() {
		const {classID, schoolState, showModal, user} = this.props;

		const isActive = OpsSchool.isClassActive(schoolState, classID);
		const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
		const isBEAM = OpsSchool.isBEAMPurchase(schoolState);

		const teachers = OpsSchool.getTeachersForClass(schoolState, classID);
		const students = OpsSchool.getStudentsForClass(schoolState, classID);

		const sortFunctions = {
			name: body => {
				return _.sortBy(body, [
					"inactive",
					r => _.toLower(_.trim(r.nameValue)),
				]);
			},
			displayName: body => {
				return _.sortBy(body, [
					"inactive",
					r => _.toLower(_.trim(r.displayNameValue)),
				]);
			},
			username: body => {
				return _.sortBy(body, ["inactive", r => _.toLower(r.usernameValue)]);
			},
			email: body => {
				return _.sortBy(body, [
					"inactive",
					r => _.toLower(_.trim(r.emailValue)),
				]);
			},
		};

		const headerClasses = {
			name: styles.name,
		};

		const widthClasses = {
			name: styles.nameWidth,
			email: styles.email,
			username: styles.username,
			password: styles.password,
			displayName: styles.displayName,
			remove: styles.removeWidth,
			status: styles.removeWidth,
		};

		const teacherCols = ["name", "email", "remove"];
		const teacherHeaderVal = ["Teachers", "Email", ""];

		const teachersTable = teachers.length ? (
			<SortableTable
				columnNames={teacherCols}
				sortableColumns={["name", "email"]}
				headers={_.zipObject(teacherCols, teacherHeaderVal)}
				initiallySortedBy="name"
				data={this.getTeacherData(schoolState, teachers, isActive, isAcademy)}
				sortFunctions={sortFunctions}
				widthClasses={widthClasses}
				headerClasses={headerClasses}
				evenRowDark={true}
				canScroll={true}
				grayOutInactive={true}
			/>
		) : (
			this.renderEmptyTable("teacher")
		);

		const studentCols = [
			"name",
			"displayName",
			"username",
			"password",
			"status",
		];
		const studentHeaderVal = [
			"Students",
			"Display Name",
			"Username",
			"Password",
			"",
		];

		if (OpsSchool.isAcademyPurchase(schoolState)) {
			_.pull(studentCols, "username", "password");
			_.pull(studentHeaderVal, "Username", "Password");
		}

		if (!isActive) {
			_.pull(studentCols, "password");
			_.pull(studentHeaderVal, "Password");
		}

		const classSchool = OpsSchool.getSchoolForClass(schoolState, classID);
		const role = OpsSchool.getBestRoleForClass(
			schoolState,
			user.userID,
			classID
		);
		const isSchoolAdmin = role === "purchaseAdmin" || role === "schoolAdmin";

		const studentsTable = students.length ? (
			<SortableTable
				columnNames={studentCols}
				sortableColumns={["name", "displayName"]}
				headers={_.zipObject(studentCols, studentHeaderVal)}
				initiallySortedBy="name"
				data={this.getStudentData(
					schoolState,
					students,
					isActive,
					isSchoolAdmin,
					isAcademy
				)}
				sortFunctions={sortFunctions}
				widthClasses={widthClasses}
				headerClasses={headerClasses}
				evenRowDark={true}
				canScroll={true}
				grayOutInactive={true}
			/>
		) : (
			this.renderEmptyTable("student")
		);

		const theClass = _.get(schoolState, ["accounts", "classes", classID]);
		const {active, year} = theClass;
		const isSchoolActive = OpsSchool.isSchoolActive(
			schoolState,
			classSchool.id
		);
		const activeText = active ? "deactivate" : "activate";

		let deactivateEl;
		if (!isAcademy) {
			if (year < OpsSchool.getPurchaseYear(schoolState) || !isSchoolActive) {
				// no button, can't activate a class in past year
			} else if (isSchoolAdmin) {
				deactivateEl = (
					<div
						className={styles[activeText]}
						onClick={() =>
							this.props.showModal("confirmInfo", {
								type: activeText,
								classID,
							})
						}
					>
						{`${activeText} class`}
					</div>
				);
			}
		}

		const printClassCards = students.length ? (
			<div className={styles.print} onClick={this.openPrint}>
				Print Sign In Info
			</div>
		) : null;
		const beamField = isBEAM ? (
			<Editable
				className={styles.classURL}
				text={theClass.classURL || "Enter class URL"}
				onClick={() =>
					this.props.showModal("updateInfo", {
						classID,
						type: "classURL",
					})
				}
			/>
		) : null;
		if (isActive && isSchoolAdmin) {
			return (
				<div className={styles.main}>
					{beamField}
					<div className={styles.table}>
						{teachersTable}
						{!isAcademy ? (
							<div
								className={styles.add}
								onClick={() => showModal("addInfo", "teacher")}
							>
								Add Teacher
							</div>
						) : null}
					</div>
					<div className={styles.table}>
						{studentsTable}
						{printClassCards}
						{!isAcademy ? (
							<div
								className={styles.add}
								onClick={() => showModal("addInfo", "student")}
							>
								Add Student
							</div>
						) : null}
					</div>
					{deactivateEl}
					{this.renderModal()}
				</div>
			);
		} else {
			return (
				<div className={styles.main}>
					{beamField}
					<div className={styles.table}>{teachersTable}</div>
					<div className={styles.table}>
						{studentsTable}
						{printClassCards}
					</div>
					{deactivateEl}
					{this.renderModal()}
				</div>
			);
		}
	},
});
